import { EpimsBaseEntityDto } from './epim-base.dto';
export class BankDto extends EpimsBaseEntityDto {
  
  BankName: string;
  SubscriptionUserId: string;  
  Version: number;
}
